import { z } from "zod";

import { sportDataSchema } from "./sport";

enum SportGameDetailsTab {
  STATS = "stats",
  PLAY_BY_PLAY = "play_by_play",
  CHAT = "chat",
}

const sportGameDetailsSchema = z.object({
  id: z.coerce.string(),
  league: z.string(),
  sport_type: z.string(),
  layout: z.string().nullish().catch(null),
  data: sportDataSchema,
  url: z.string(),
  tabs: z.array(z.nativeEnum(SportGameDetailsTab)).nullish().catch([]),
  box_score: z
    .object({
      columns: z.array(z.string()),
      home: z.object({
        abbreviation: z.string(),
        scores: z.array(z.number()),
      }),
      away: z.object({
        abbreviation: z.string(),
        scores: z.array(z.number()),
      }),
    })
    .nullable()
    .catch(null),
});

const sportGameStatsSchema = z
  .object({
    stat_key: z.coerce.string(),
    stat_label: z.string(),
    home_value: z.number().catch(0),
    away_value: z.number().catch(0),
    position: z.number(),
  })
  .transform((data) => {
    return {
      ...data,
      id: data.stat_key,
    };
  });

const sportGamePlaySchema = z
  .object({
    play_id: z.coerce.string(),
    sequence: z.number(),
    period: z.string(),
    time: z.string().nullable(),
    team_abbreviation: z.string().nullable(),
    play_type: z.string(),
    title: z.string(),
    description: z.string(),
    home_score: z.number().nullable(),
    away_score: z.number().nullable(),
  })
  .transform((data) => {
    return {
      ...data,
      id: data.play_id,
    };
  });

type SportGameDetails = z.infer<typeof sportGameDetailsSchema>;
type SportGameStat = z.infer<typeof sportGameStatsSchema>;
type SportGamePlay = z.infer<typeof sportGamePlaySchema>;

export {
  sportGameDetailsSchema,
  sportGameStatsSchema,
  sportGamePlaySchema,
  type SportGameDetails,
  type SportGameStat,
  type SportGamePlay,
  SportGameDetailsTab,
};
